import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../utils/api';

const ProtectedCourierRoute = ({ children }) => {
  const [courierEnabled, setCourierEnabled] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkCourierStatus = async () => {
      try {
        const response = await api.get('/vendors/profile', {
          withCredentials: true
        });
        
        console.log('Courier status:', response.data?.courierService?.enabled);
        setCourierEnabled(response.data?.courierService?.enabled === true);
      } catch (error) {
        console.error('Error checking courier status:', error);
        setCourierEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    checkCourierStatus();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!courierEnabled) {
    return <Navigate to="/courier-login" />;
  }

  return children;
};

export default ProtectedCourierRoute;